
import React from "react";
import { Book, Users, FileText, Target, Calendar } from "lucide-react";

const features = [
  {
    icon: Book,
    title: "Aulas Semanais",
    description: "mentalidade, treino, hábitos",
  },
  {
    icon: Calendar,
    title: "Call Mensal",
    description: "dúvidas, casos e networking direcionado",
  },
  {
    icon: Users,
    title: "Networking",
    description: "grupo de conexão no WhatsApp + Discord",
  },
  {
    icon: FileText,
    title: "Planilhas e Templates",
    description: "treino, nutrição e organização pessoal",
  },
  {
    icon: Target,
    title: "Estilo de Vida Real",
    description: "códigos simples, práticos e poderosos",
  },
];

const FeaturesSection: React.FC = () => {
  return (
    <section className="section-container relative overflow-hidden" id="features">
      <div className="absolute inset-0 particles-container">
        {[...Array(20)].map((_, i) => (
          <span 
            key={i} 
            className="particle" 
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              width: `${Math.random() * 4 + 1}px`,
              height: `${Math.random() * 4 + 1}px`,
            }}
          />
        ))}
      </div>
      
      <h2 className="text-3xl md:text-4xl font-bold mb-16 text-center relative z-10">
        O que você acessa quando entra no Escape Club
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 relative z-10">
        {features.map((feature, index) => (
          <div
            key={index}
            className="card-border p-8 flex flex-col items-center text-center scroll-reveal"
          >
            <feature.icon className="w-10 h-10 mb-6 stroke-1" />
            <h3 className="text-xl font-bold mb-3">🔥 {feature.title}</h3>
            <p className="opacity-80">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;
